import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A1A1E] text-[#9CA3AF] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#CFA968] flex items-center justify-center">
                <span className="font-serif text-[#0A1A1E] text-2xl leading-none">H</span>
              </div>
              <div>
                <div className="font-serif text-xl text-white">H. Elliot Associates</div>
                <div className="text-[10px] uppercase tracking-[0.25em]">Established 2012 · Rockville, MD</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md">
              A financial planning firm specializing in retirement planning and tax planning
              for federal employees, individuals, and small-business owners. Investment-adviser
              services are not currently offered.
            </p>
            <div className="hairline my-6 bg-white/10" />
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#CFA968] mb-3">— Certifications</div>
            <ul className="text-xs space-y-1.5">
              <li>State of Maryland — MBE (MDOT)</li>
              <li>Montgomery County, MD — LSBRP</li>
              <li>Active SAM.gov · UEI: QLQ9DHP73RF2</li>
            </ul>
            <div className="hairline my-6 bg-white/10" />
            <div className="text-sm space-y-2">
              <div>451 N. Hungerford Dr., Suite 119 · Rockville, MD 20850</div>
              <div>(571) 598-5790 · helliotassociates@gmail.com</div>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-[#CFA968] mb-5">Firm</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/our-clients" className="hover:text-white">Our Clients</Link></li>
              <li><Link to="/team" className="hover:text-white">The Practice</Link></li>
              <li><Link to="/insights" className="hover:text-white">Insights</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-[#CFA968] mb-5">Clients</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/portal/login" className="hover:text-white">Client Portal</Link></li>
              <li>
                <a
                  href="https://www.encyro.com/helliotassociates@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                  data-testid="footer-encyro-link"
                >
                  Send Documents (Encyro) →
                </a>
              </li>
              <li><Link to="/book" className="hover:text-white">Book a Call</Link></li>
              <li><Link to="/disclosures" className="hover:text-white">Disclosures</Link></li>
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
              <li><Link to="/refunds" className="hover:text-white">Refund Policy</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[#CFA968] mb-5">Compliance</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://www.irs.gov/tax-professionals/enrolled-agents"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-ea-link"
                  className="hover:text-white"
                >
                  About Enrolled Agents (IRS) →
                </a>
              </li>
              <li>
                <Link to="/disclosures" className="hover:text-white">
                  Disclosures & Licensure →
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white">
                  Privacy Policy →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline mt-16 mb-8 bg-white/10" />

        <div className="text-xs leading-relaxed text-[#6B7280] max-w-5xl space-y-3">
          <p>
            H. Elliot Associates, LLC is a financial planning firm. The firm currently
            provides retirement planning, tax preparation, tax planning, and IRS
            representation services through the principal's federal Enrolled Agent (EA)
            licensure with the U.S. Internal Revenue Service. Retirement-related work is
            limited to the planning and tax aspects of retirement decisions and does{" "}
            <strong className="text-[#9CA3AF]">not</strong> constitute investment advice.
            The firm is <strong className="text-[#9CA3AF]">not</strong> currently registered
            as an investment adviser with the SEC or any state securities authority and does{" "}
            <strong className="text-[#9CA3AF]">not</strong> provide investment advice for
            compensation.
          </p>
          <p>
            Information on this website is for general educational purposes only and is not
            intended as, and should not be construed as, individualized tax, legal, or investment
            advice. Any reference to retirement, estate, or wealth-management topics is educational
            and does not constitute a recommendation. Please consult a qualified professional
            regarding your specific situation.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 pt-4">
            <span>© {new Date().getFullYear()} H. Elliot Associates, LLC</span>
            <span>Federally Licensed by the IRS as an Enrolled Agent</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
